export default {
    namespaced: false,

    getters: {
        environmentNameSafe(state) {
            return import.meta.env.VITE_NODE_DEBUG === '1' ? import.meta.env.VITE_APP_ENV : null
        },
    },
}
